/**
 *
 * Product Carousel with Filters
 *
 */

export default function obProductCarouselWithFilters() {

    function initializeCarousel($carousel) {
        if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
        }

        $carousel.slick({
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slide: '.ob-carouselSlide',
            slidesToShow: 1.2,
            slidesToScroll: 1,
            swipe: true,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        arrows: true,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    function constructFilterList($filterList, $carousel) {
        const uniqueTags = [];

        $carousel.find('.ob-carouselSlide').each((_, card) => {
            const $card = $(card);
            const tags = $card.data('filter-tags').split(',').map(t => t.trim());

            tags.forEach(tag => {
                if (tag && !uniqueTags.includes(tag)) {
                    uniqueTags.push(tag);
                }
            });
        });

        uniqueTags.forEach(tag => {
            $filterList.append(`<li data-tag="${tag}">${tag}</li>`);
        });
    }

    function setup() {
        $('.ob-featuredCarousel').each((_, container) => {
            const $container = $(container);

            if ($container.data('carousel-init') === true) return;
            $container.data('carousel-init', true);

            const $carousel = $container.find('.ob-carousel');
            const $filterList = $container.find('.ob-carouselFilter-list');

            constructFilterList($filterList, $carousel);
            initializeCarousel($carousel);

            $filterList.children('li').off().on('click', event => {
                const $targetFilter = $(event.currentTarget);
                const selectedTag = $targetFilter.data('tag');

                $filterList.children('li').removeClass('is-active');
                $targetFilter.addClass('is-active');

                $carousel.slick('slickUnfilter');
                $carousel.slick('slickFilter', (__, product) => {
                    const $product = $(product);
                    const productTags = $product.data('filter-tags').split(',').map(t => t.trim());
                    if (selectedTag === 'all') return true;
                    return productTags.includes(selectedTag);
                });
            });
        });
    }

    document.addEventListener('init.obCarousel', setup);

    setup();
}
